module.exports = __webpack_public_path__ + "img/6solved-1_ergebnis.81d2f256.webp";